import { Button } from 'src/components/ui/button';
import { useGT } from 'gt-react';
import { DotsThreeVerticalIcon } from '@phosphor-icons/react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'src/components/ui/dropdown-menu';
import { useToast } from 'src/context/ToastContext';
import { useCan } from 'src/hooks/useCan';
import { Action, Subject } from '@erp/authz';
import { useGenerateAuditReport } from '@/api/rpc/hooks/audit-reports/useGenerateAuditReport';
import { AuditModule } from '@erp/shared-types';

function OptionsMenu({
  purchaseOrderNumber,
}: {
  purchaseOrderNumber?: string;
}) {
  const gt = useGT();
  const { showToast } = useToast();
  const [canReport] = useCan(Action.Report, Subject.SalesOrderDraft);
  const generateAuditMutation = useGenerateAuditReport();

  if (!canReport || !purchaseOrderNumber) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id="long-button"
          variant="ghost"
          size="icon"
          aria-haspopup="true"
          className="m-2 -mr-2"
        >
          <DotsThreeVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          disabled={generateAuditMutation.isPending}
          onClick={() => {
            if (!purchaseOrderNumber) return;
            generateAuditMutation.mutate(
              {
                module: AuditModule.OMS,
                formats: ['pdf'],
                filters: { purchaseOrderNumbers: [purchaseOrderNumber] },
              },
              {
                onError: () => {
                  showToast({
                    message: gt('Failed to generate audit report', {
                      context: 'toast when audit report generation fails',
                    }),
                    color: 'error',
                    icon: 'error',
                  });
                },
              },
            );
          }}
        >
          <p>
            {generateAuditMutation.isPending
              ? gt('Generating Audit Report...', {
                  context: 'menu action loading state',
                })
              : gt('Generate Audit Report', {
                  context: 'menu action to generate audit report for this PO',
                })}
          </p>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default OptionsMenu;
